import type {IdGetterObj} from '@apollo/client';

export interface WebflowIdGetterObj extends IdGetterObj {
  cmsLocaleId?: string | null;
}

/**
 * dataIdFromObject function used by both the Apollo client in the renderer and the designer.
 *
 * Custom ID resolution rules:
 * - `sku_props`: no ID (returns undefined)
 * - `commerce_subscription`: uses `_id`
 * - `collections` / `CMSNamespace`: singleton types keyed by __typename
 * - default: composite key `id_cmsLocaleId` when locale is present, otherwise `id`
 */
export function webflowDataIdFromObject(
  object: WebflowIdGetterObj
): string | undefined {
  switch (object.__typename) {
    case 'sku_props':
      return undefined;
    case 'commerce_subscription':
      return object._id;
    case 'collections':
      // `collections` does not have an ID, so we must
      // use a hard-coded string so that Apollo cache
      // can merge the `collections` objects together.
      return object.__typename;
    case 'CMSNamespace':
      // `CMSNamespace` does not have an ID, so we must
      // use a hard-coded string so that Apollo cache
      // can merge the `CMSNamespace` objects together.
      return object.__typename;
    default:
      if (object.cmsLocaleId) {
        return `${object.id}_${object.cmsLocaleId}`;
      }
      return object.id;
  }
}
